module.exports = __webpack_public_path__ + "e9512c68efbb271550ca733c19a1914b.svg";